import { Injectable } from '@angular/core';
import {
  NbToastrService,
  NbGlobalPhysicalPosition,
  NbComponentStatus,
  NbIconConfig,
  NbToastRef,
  NbToastrConfig,
} from '@nebular/theme';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastrService: NbToastrService) {}

  showToast(type: NbComponentStatus, title: string, content?: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      limit: 4,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    this.toastrService.show(content, title, config);
  }
  
  info(title: string, content?: string) {
    const config = {
      status: 'info',
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      limit: 4,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
      icon: 'info-outline'
    };

    this.toastrService.show(content, title, config);
  }

  warn(title: string, content?: string) {
    const config = {
      status: 'warning',
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      limit: 4,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false
    };

    this.toastrService.show(content, title, config);
  }

  hold(type: NbComponentStatus, title: string, content?: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 0,
      limit: 4,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };

    this.toastrService.show(content, title, config);
  }

  holdDuplicated(type: NbComponentStatus, title: string, content?: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 0,
      limit: 4,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: true,
    };

    this.toastrService.show(content, title, config);
  }

  /**
   * 알림메시지에 버튼을 추가한다.
   * @param firstButtonMsg 
   * @param secondButtonMsg 
   * @param firstButtonEvent 
   * @param secondButtonEvent 
   * @param className 
   * @param showSecondButton 
   */
  setButton(
    firstButtonMsg?: string,
    secondButtonMsg?: string,
    firstButtonEvent?: any,
    secondButtonEvent?: any,
    className: string = "",
    showSecondButton: boolean = true,
  ): void {
    let buttonArea = document.createElement("div");
    let firstButton = document.createElement("button");
    let secondButton = document.createElement("button");

    buttonArea.className = "button-area";

    firstButton.innerHTML = firstButtonMsg;
    buttonArea.appendChild(firstButton);

    if (showSecondButton) {
      secondButton.innerHTML = secondButtonMsg;
      buttonArea.appendChild(secondButton);
    }

    document.querySelector("nb-toast." + className).appendChild(buttonArea);

    if (firstButtonEvent)
      firstButton.onclick = firstButtonEvent;
    
    if (secondButtonEvent)
      secondButton.onclick = secondButtonEvent;
  }

  /**
   * 알림 메시지를 띄우며 NbToastRef 객체를 리턴한다.
   * @param msg 
   * @param title 
   * @param status 
   * @param icon 
   * @param className 
   * @param holding 
   * @param options 
   * @returns 
   */
  getToast(
    msg: string,
    title?: string,
    status?: NbComponentStatus,
    icon?: NbIconConfig,
    className: string = "",
    holding: boolean = false,
    options: Partial<NbToastrConfig> = null
  ): NbToastRef {
    let toast: NbToastRef = this.toastrService.show(
      msg,
      title,
      options ? options : {
        duration: holding ? 0 : 5000,
        destroyByClick : !holding,
        status: status || "info",
        icon: icon || { icon: "alert-circle-outline", pack: "eva" },
        toastClass: className
      }
    );

    return toast;
  }
}
